export const profileData = [
  {
    profile: [
      {
        id:1,
        placeholder: "First name",
        required: true,
        type: "text",
        name: "firstName",
        label: "First Name",
        maxlength:30,
        disabled:true
      },
      {
        id:2,
        placeholder: "Last name",
        required: false,
        type: "text",
        name: "lastName",
        label: "Last Name",
        maxlength:30,
        disabled:true
      },
      { 
        id:3,
        placeholder: "Mobile Number",
        required: true,
        type: "text",
        name: "mobile",
        label: "Mobile Number",
        maxlength:10, 
        countryCode:true,
        verify:true,
        disabled:true 
      },
      {
        id:4,
        placeholder: "Email",
        required: true,
        type: "text",
        name: "email",
        label: "Email",
        maxlength:100,
        verify:true,
        disabled:true
      },
    ],  
  },
]